export default "__VITE_ASSET__DVd$G$gc__"